module.exports = __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/psych_soc-92490c2ba6704536b1062f645bec6ec0.svg";